import React,{useContext, useEffect, useCallback} from "react";
import { View, StyleSheet, ScrollView, Platform } from "react-native";
import { useFocusEffect } from '@react-navigation/native'
import { FontAwesome5, FontAwesome, MaterialIcons } from "@expo/vector-icons";
import Text from "../components/Text";
import colors from "../config/colors";
import Screen from "../components/Screen";
import routes from "../navigation/routes";
import AuthContext from "../auth/context";

function ListingSelectSeedOrPubtionScreen({ navigation }) {

useFocusEffect(
useCallback(() => {
    if(JSON.parse(user).alias === 'notUser' ){
      //alert('notUser')
      navigation.navigate('ViewImage')
    }
   }, [])
)
  // useEffect(() => {
         
  //   if(JSON.parse(user).alias === 'notUser' ){
  //     alert('notUser')
  //     navigation.navigate('ViewImage')
  //   }
  // }, []); 
  const { user, setUser } = useContext(AuthContext);    

  return (

    <Screen style={styles.card}>
      <ScrollView scrollToEnd={({ animated: false })}>
        <View style={styles.viewQuestion} >
          <Text style={styles.hola} numberOfLines={1}>
            ¡Hola!
          </Text>
          <Text style={styles.question} numberOfLines={2}>
            Por favor selecciona lo que deseas crear :
          </Text>
        </View>
        <View >
          <View style={styles.detailsContainer}>
            <Text style={styles.subTitle} numberOfLines={1}>
              ¡Empieza una causa para mejorar el planeta!
            </Text>
            <View >
              <FontAwesome5
                style={styles.icono}
                name={"seedling"}
                size={45}
                onPress={() => navigation.navigate(routes.ADD_SEED)}
              />
            </View>
            <Text style={styles.title} >
              Semilla
            </Text>
          </View>
        </View>
        <View >
          <View style={styles.detailsContainer}>
            <Text style={styles.subTitle} numberOfLines={1}>
              ¡Comparte momentos de tu vida!
            </Text>
            <View >
              <FontAwesome
                style={styles.iconoFoto}
                name={"photo"}
                size={45}
                onPress={() => navigation.navigate(routes.LISTING_EDIT)}
              />
            </View>
            <Text style={styles.title} >
              Publicación
            </Text>
          </View>
        </View>
        <View >
          {
           //.......................................................
           //Sección para ir al formulario de creación de historias
           //......................................................
          }
          {
            Platform.OS === 'web'?
            null
            :
            <View style={styles.detailsContainer}>
            <Text style={styles.subTitle} numberOfLines={1}>
              ¡Comparte una historia!
            </Text>
            <View >
              < MaterialIcons
                style={styles.iconoFoto}
                name={"camera-enhance"}
                size={45}
                onPress={() => navigation.navigate(routes.ADD_HISTORY)}
              />
            </View>
            <Text style={styles.title} >
              Historia
            </Text>
          </View>
          }  
        </View>
      </ScrollView>
    </Screen>
  );
}

const styles = StyleSheet.create({
  card: {
    // backgroundColor: colors.white,
    marginTop: 20,
    overflow: "hidden",
    width: "100%",
    alignItems: "center",

  },
  detailsContainer: {
    padding: 20,
    alignItems: "center",
  },
  icono: {
    width: "100%",
    color: colors.green,
    backgroundColor: colors.pistache,
    padding: 30,
    borderRadius: 55,
    overflow: "hidden",
  },
  iconoFoto: {
    width: "100%",
    color: "white",
    backgroundColor: colors.fuente,
    padding: 30,
    borderRadius: 55,
    overflow: "hidden",
  },
  viewQuestion: {
    color: colors.dark,
    width: "100%",
    alignItems: "center",
    padding: 15,
    //fontSize: 20,
  },
  hola: {
    color: colors.dark,
    // width: "100%",
    alignItems: "center",
    padding: 15,
    fontSize: 35,
    textAlign: "center",
  },
  question: {
    color: colors.dark,
    //width: "100%",
    alignItems: "center",
    padding: 15,
    fontSize: 25,
    textAlign: "center",
  },
  subTitle: {
    color: colors.dark,
    marginBottom: 12,
  },
  title: {
    marginBottom: 7,
    padding: 15,
    fontSize: 20,
    fontWeight: "bold",
  },

});

export default ListingSelectSeedOrPubtionScreen;
